<template lang="pug">
    .notice-banner(
        v-if="!dismissed"
        :style="bannerStyle"
    )
        .notice-banner__inner
            slot
        v-btn.notice-banner__close(
            v-if="isDismissable"
            icon
            small
            @click="dismiss"
        )
            v-icon(small) mdi-close
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
    data() {
        return {
            dismissed: false,
        };
    },
    props: {
        backgroundColor: {
            type: String,
            default: 'var(--volie-blue-10)',
        },
        isDismissable: {
            type: Boolean,
            default: false,
        },
        // when set, uses a gradient instead of solid backgroundColor. 'default' = volie-blue -> volie-teal, 'pulse' = volie-teal -> pulse-green
        gradientVariant: {
            type: String as () => 'default' | 'pulse' | null,
            default: null,
            validator: (v: string | null) => v === null || v === 'default' || v === 'pulse',
        },
        /** 0–1; applied to the background only (gradient or solid). Default 1. */
        opacity: {
            type: Number,
            default: 1,
            validator: (v: number) => v >= 0 && v <= 1,
        },
    },
    computed: {
        bannerStyle(): Record<string, string> {
            const bg =
                this.gradientVariant
                    ? {
                          default:
                              'linear-gradient(to right, var(--volie-blue), var(--volie-teal))',
                          pulse:
                              'linear-gradient(to right, var(--volie-teal), var(--pulse-green))',
                      }[this.gradientVariant]
                    : this.backgroundColor;
            return {
                '--banner-bg': bg,
                '--banner-opacity': String(this.opacity),
            };
        },
    },
    methods: {
        dismiss() {
            this.dismissed = true;
        },
    },
});
</script>

<style lang="scss" scoped>
.notice-banner {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 10px 16px;
    position: relative;
    width: 100%;

    &::before {
        content: '';
        position: absolute;
        inset: 0;
        background: var(--banner-bg);
        opacity: var(--banner-opacity, 1);
        z-index: 0;
    }

    &__inner {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        position: relative;
        z-index: 1;
    }

    &__close {
        flex-shrink: 0;
        margin-left: 8px;
        position: relative;
        z-index: 1;
    }
}
</style>
